module.exports = __webpack_public_path__ + "static/media/daphne-lose.db17e817.png";